import request from '../../request'
import {translation} from '../../endpoints'

export default class translationApi {
  static async getTranslationsForText(lang, sourceLanguage, text) {
    return request({
      url: translation.getTranslationsForText(),
      method: 'POST',
      data: {
        text: text,
        sourceLanguageCode: sourceLanguage,
        targetLanguageCode: lang,
      },
    })
  }
}
